import type { MeResponse } from '@giyus/api-client';
import { createContext, useContext } from 'react';

import type { AuthBackend, AuthSnapshot } from './types';

export interface AuthContextValue extends AuthSnapshot {
  readonly backend: AuthBackend;
  readonly signIn: () => Promise<void>;
  readonly signOut: () => Promise<void>;
  /** Recarrega `/me` (ex.: após aceitar uma delegação). */
  readonly refreshMe: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used within <AuthProvider>.');
  }
  return value;
}

/** `/me` do usuário autenticado. Só pode ser usado abaixo do `AuthGate` (status `authenticated`). */
export function useMe(): MeResponse {
  const { me } = useAuth();
  if (!me) {
    throw new Error('useMe requires an authenticated session (render below <AuthGate>).');
  }
  return me;
}
